
const handleAddClickListenersBySelector = (selector, callback) => {
    Array.prototype.map
        .call(
            document.querySelectorAll(selector),
            (element) => element.addEventListener('click', callback)
        );
}

const handleSubscriptionButtonClick = (data = {}) => {
    return new Promise((resolve) => {
        trackEvent('subscription_button', 'User', 'Subscription Button', {
            element_description: data.click_text,
        })

        resolve();
    });
};

const prepareActionDataByElement = (element) => {
    const data = {};

    let dataText = element?.getAttribute('data-text') || element.innerHTML;

    if(dataText) {
        data.click_text = dataText.replace(/<[^>]+>/g, ' ')?.replace(/\s+/g, " ")?.trim();
    }

    return data;
}

handleAddClickListenersBySelector('a[href$="/plans"]', async (e) => {
    const { currentTarget } = e;

    await handleSubscriptionButtonClick({
        ...prepareActionDataByElement(currentTarget),
    });
});

const handleExperimentEvent = (exp_variant_string) => {
    trackEvent('experience_impression', 'A/B Test', exp_variant_string, {
        exp_variant_string,
    });
};

export { handleExperimentEvent };
